export default __webpack_public_path__ + "static/media/House-Icon.80582f38.svg";